import React from "react";
import MovingComponent from "react-moving-text";

const DashboardBanner = () => {
  const background =
    "data:image/svg+xml;charset=utf-8,%3Csvg shape-rendering='geometricPrecision' text-rendering='geometricPrecision' viewBox='0 0 1920 1080' xmlns='http://www.w3.org/2000/svg'%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='-687' x2='-687' y1='-9' y2='760'%3E%3Cstop offset='0' stop-color='%23fff' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23fff'/%3E%3C/linearGradient%3E%3Cpath d='M0 0c-245.345 263.66-553.5 455.5-1020 755l-354 5C-733 437-199.131 203.325-8-9z' fill='url(%23a)' transform='translate(1582 503)'/%3E%3Cpath d='m1421.86 418.265 331.999-129.93-235.655 157.216z' fill='%23fff'/%3E%3Cpath d='M1753.859 288.335 1518.204 445.55l47.158 81.22z' fill='%23ddd'/%3E%3Cpath d='M1753.859 288.335 1569.966 458.91 1690.997 493z' fill='%23fff'/%3E%3Cpath d='m1565.362 526.77 4.604-67.859 40.034 11.09z' fill='%23a0a0a0'/%3E%3C/svg%3E";
  return (
    <div id="about">
      <div className="relative w-full xl:mx-auto md:px-10 h-[24rem] sm:h-[34rem] overflow-hidden bg-gradient-to-b via-gray-200 to-gray-300 from-gray-0 bg-[#00756a]">
        <div className="hidden pointer-events-none aspect-[128/75] absolute left-[0px] top-[5rem] z-0 w-full origin-left rotate-[-20deg] sm:left-[10rem] sm:top-[10rem]">
          {/* <div className="relative h-full w-full">
            <div
              className="absolute z-10 origin-bottom animate-squigglebar"
              style={{
                animationFillMode: "backwards",
                animationDuration: "0.18s",
                animationDelay: "0.3s",
                animationTimingFunction: "cubicBezier(0.25, 0.46, 0.45, 0.94)",
                background:
                  "linear-gradient(100grad, rgb(222, 255, 52), rgb(140, 249, 124))",
                left: "0%",
                height: "78%",
                width: "15%",
                top: "22%",
              }}
            ></div>
            <div
              className="absolute animate-squigglediagonal"
              style={{
                animationFillMode: "backwards",
                animationDuration: "0.18s",
                animationDelay: "0.43s",
                animationTimingFunction: "cubicBezier(0.25, 0.46, 0.45, 0.94)",
                background:
                  "linear-gradient(100grad, rgb(101, 247, 95), rgb(18, 240, 170))",
                left: "15%",
                height: "70.6667%",
                width: "13.3333%",
                top: "22%",
                clipPath: "polygon(0px 0px, 100% 41%, 100% 100%, 0px 59%)",
              }}
            ></div>
            <div
              className="absolute z-10 origin-bottom animate-squigglebar"
              style={{
                animationFillMode: "backwards",
                animationDuration: "0.18s",
                animationDelay: "0.56s",
                animationTimingFunction: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                background:
                  "linear-gradient(100grad, rgb(69, 244, 188), rgb(51, 223, 223))",
                left: "28.3333%",
                height: "78%",
                width: "15%",
                top: "14.6667%",
              }}
            ></div>
            <div
              className="absolute animate-squigglediagonal"
              style={{
                animationFillMode: "backwards",
                animationDuration: "0.18s",
                animationDelay: "0.69s",
                animationTimingFunction: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                background:
                  "linear-gradient(100grad, rgb(1, 211, 216), rgb(2, 183, 241))",
                left: "43.3333%",
                height: "70.6667%",
                width: "13.3333%",
                top: "14.6667%",
                clipPath: "polygon(0px 0px, 100% 41%, 100% 100%, 0px 59%)",
              }}
            ></div>
            <div
              className="absolute z-10 origin-bottom animate-squigglebar"
              style={{
                animationFillMode: "backwards",
                animationDuration: "0.18s",
                animationDelay: "0.82s",
                animationTimingFunction: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                background:
                  "linear-gradient(100grad, rgb(52, 200, 244), rgb(52, 188, 255))",
                left: "56.6667%",
                height: "78%",
                width: "15%",
                top: "7.33333%",
              }}
            ></div>
            <div
              className="absolute animate-squigglediagonal"
              style={{
                animationFillMode: "backwards",
                animationDuration: "0.18s",
                animationDelay: "0.95s",
                animationTimingFunction: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                background:
                  "linear-gradient(100grad, rgb(2, 167, 255), rgb(2, 167, 255))",
                left: "71.6667%",
                height: "70.6667%",
                width: "13.3333%",
                top: "7.33333%",
                clipPath: "polygon(0px 0px, 100% 41%, 100% 100%, 0px 59%)",
              }}
            ></div>
            <div
              className="absolute z-10 origin-bottom animate-squigglebar"
              style={{
                animationFillMode: "backwards",
                animationDuration: "1s",
                animationDelay: "1.08s",
                animationTimingFunction: "cubic-bezier(0.23, 1, 0.32, 1)",
                background:
                  "linear-gradient(100grad, rgb(52, 188, 255), rgb(52, 188, 255))",
                left: "85%",
                height: "78%",
                width: "15%",
                top: "0%",
              }}
            ></div>
          </div> */}
        </div>

        <div className="w-full sm:max-lg:w-2/3 lg:w-1/2 mt-14 sm:mt-8 px-3">
          <div className="text-lg sm:text-4xl font-notosans font-bold leading-15 text-center text-[#ffe6ae]">
            <MovingComponent
              type="slideInFromTop"
              duration="1600ms"
              delay="0s"
              direction="normal"
              timing="linear"
              iteration="1"
              fillMode="none"
            >
              Transform Your Business with Cutting-Edge IT Solutions Prepared
              for Tomorrow's Challenges
            </MovingComponent>
          </div>
          <div className="text-sm sm:text-lg poppins-regular mt-7 w-full text-center text-white">
            <MovingComponent
              type="slideInFromTop"
              duration="1600ms"
              delay="0s"
              direction="normal"
              timing="linear"
              iteration="1"
              fillMode="none"
            >
              Where innovation intersects with excellence. Serving as your
              committed IT service ally
            </MovingComponent>
          </div>

          <div className="flex justify-center items-center gap-2 sm:gap-5 sm:mt-10 my-3 flex-wrap">
            <span className="border-[1px] border-[#ffe6ae] rounded-full p-1 sm:p-2 text-xs sm:text-xsm poppins-regular text-[#ffe6ae]">
              Web Development
            </span>
            <span className="border-[1px] border-[#ffe6ae] rounded-full p-1 sm:p-2 text-xs sm:text-xsm poppins-regular text-[#ffe6ae]">
              Database Migration
            </span>
            <span className="border-[1px] border-[#ffe6ae] rounded-full p-1 sm:p-2 text-xs sm:text-xsm poppins-regular text-[#ffe6ae]">
              BI Analytics
            </span>
            <span className="border-[1px] border-[#ffe6ae] rounded-full p-1 sm:p-2 text-xs sm:text-xsm poppins-regular text-[#ffe6ae]">
              Cloud Management
            </span>
            <span className="border-[1px] border-[#ffe6ae] rounded-full p-1 sm:p-2 text-xs sm:text-xsm poppins-regular text-[#ffe6ae]">
              Cloud Migration
            </span>
            <span className="border-[1px] border-[#ffe6ae] rounded-full p-1 sm:p-2 text-xs sm:text-xsm poppins-regular text-[#ffe6ae]">
              Cloud Consultation
            </span>
          </div>
        </div>
        <div className="w-1/2 sm:max-md:w-1/3 md:w-1/2">{/* <img src={background} /> */}</div>

        <div className="hidden sm:block w-full absolute -top-40 sm:max-lg:-top-10">
          <img src={background} />
        </div>

        <div className="absolute w-full left-0 right-0 bottom-0 rotate-180">
          <svg
            data-v-6da3ec0c=""
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="w-full h-[40px] sm:h-[100px]"
          >
            <path
              data-v-6da3ec0c=""
              d="M1200 0L0 0 892.25 114.72 1200 0z"
              className="shape-fill"
              style={{ fill: `rgb(255, 255, 255)` }}
            ></path>
          </svg>
        </div>
      </div>

      <div className="relative h-56">
        <div className="bg-white  top-0 sm:top-[-5rem] w-[80%] sm:w-full left-0 mx-auto rounded-3xl right-0 p-10">
          <p className="text-center poppins-semibold text-2xl sm:text-5xl text-[#333e49]">
            Welcome to Flint
          </p>
          <p className="text-center font-notosans text-lg sm:text-xl mt-4 italic">
            "We Provide the Solutions for Your Business"
          </p>
          <p className="text-center  poppins-regular text-sm sm:text-lg mt-4">
            Unlock the transformative potential of IT services with Flint
            InfoTech. Collaborate with us to enhance your business, faster
            innovation, and attain unmatched success in today's digital era
          </p>
        </div>
      </div>
    </div>
  );
};

export default DashboardBanner;
